import AutoLinkHeader from 'components/AutoLinkHeader'
import CodeBlock from 'components/CodeBlock'
import React from 'react'

const mdxComponents = {
  h1: props => <AutoLinkHeader is="h1" {...props} />,
  h2: props => <AutoLinkHeader is="h2" {...props} />,
  h3: props => <AutoLinkHeader is="h3" {...props} />,
  h4: props => <AutoLinkHeader is="h4" {...props} />,
  h5: props => <AutoLinkHeader is="h5" {...props} />,
  h6: props => <AutoLinkHeader is="h6" {...props} />,
  pre: props => <CodeBlock {...props} />,
  code: props => <code {...props} />,
  table: props => (
    <div className="table-wrapper">
      <table {...props} />
    </div>
  ),

  // Our shiki plugin will use the following component 
  CodeBlock: props => <CodeBlock {...props} />,
}

export default mdxComponents
